import { render, staticRenderFns } from "./m-edit-select-organization-owned-endpoint.vue?vue&type=template&id=3660e234&scoped=true&"
import script from "./m-edit-select-organization-owned-endpoint.vue?vue&type=script&lang=js&"
export * from "./m-edit-select-organization-owned-endpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3660e234",
  null
  
)

export default component.exports